import React, { useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { GiTakeMyMoney } from "react-icons/gi";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { Button, Container } from "@material-ui/core";
import {
  Card,
  Carousel,
  Col,
  Dropdown,
  Form,
  Row,
  InputGroup,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import axios from "axios";
import Select from "react-select";
import Geocode from "react-geocode";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Container>
          <Box>{children}</Box>
        </Container>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));

// Initialize Google Geocoding API
Geocode.setApiKey("AIzaSyClbig43rDJiDAjE8QVefX2LNZpczeBt5w");
Geocode.setLanguage("en");
Geocode.setLocationType("ROOFTOP");

function Home() {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [selectCity, setselectCity] = React.useState("");
  const [selectlocality, setselectlocality] = React.useState([]);
  const [apartmentType, setapartmentType] = React.useState("");
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [propertyType, setpropertyType] = React.useState("");
  const [getcitydata, setgetcitydata] = React.useState([]);

  const [fullhouse, setfullhouse] = React.useState(false);

  const [pghostel, setpghostel] = React.useState(false);

  const [flatmates, setflatmates] = React.useState(false);

  const [rent, setrent] = React.useState(false);

  const [buy, setbuy] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const open = () => {
    if (user) {
      window.location.assign("/propertymanage");
    } else {
      alert("please login");
    }
  };

  // console.log(selectlocality);

  const handleSearch = async (inputValue) => {
    if (!inputValue) return;
    if (!selectCity) return alert("Please select city!");

    try {
      const response = await Geocode.fromAddress(`${inputValue}, ${selectCity}`);
      const results = response.results;

      const formattedOptions = results.slice(0, 5).map((result) => ({
        value: result.geometry.location,
        label: result.formatted_address,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching geocode data:", error);
    }
  };

  const handleInputChange = (inputValue) => {
    handleSearch(inputValue);
  };

  const handleChange1 = (options) => {
    setSelectedOptions(options); // Store multiple selected options
    console.log("Selected locations:", options);
    setselectlocality(options);
  };
  useEffect(() => {
    getcity();
  }, []);

  const getcity = () => {
    try {
      axios
        .get("https://vrpmpro.com/api/propertyForOwner/getAddCity")
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            setgetcitydata(response.data.cityList1);
            return;
          } else {
            alert("Can't able to fetch ");
            return;
          }
        });
    } catch (error) {
      console.log(error.message.data);
      alert("Can't able  to fetch");
      return;
    }
  };

  return (
    <>
      <div
        className=" row me-0"
        style={{
          backgroundImage: "url(" + "/img/houseliv.jpg" + ")",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="col-md-3"></div>
        <div className="col-md-6">
          <h1
            className="mt-5 "
            style={{
              fontSize: "35px",
              color: "#1b2435",
              textAlign: "center",
              height: "30%",
            }}
          >
            FIND YOUR DREAM HOME
          </h1>
          <h5
            className="mt-4"
            style={{ textAlign: "center", color: "#1b2435" }}
          >
            The best properties are published here
          </h5>
        </div>
        <div className="col-md-3"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-2"></div>
        <div className="col-md-8 mt-3">
          <AppBar
            position="static"
            color="default"
            className="rentBar searchbar"
            // style={{ background: "red" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              // variant="fullWidth"
              aria-label="full width tabs example"
              centered
              // flexContainer
            >
              <Tab label="Buy" {...a11yProps(0)} />

              <Tab label="Rent" {...a11yProps(1)} />
              <Tab label="Commercial" {...a11yProps(2)} />
              <Tab label="Plots" {...a11yProps(3)} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel
              style={{
                borderStyle: "ridge",
              }}
              value={value}
              index={0}
              dir={theme.direction}
            >
              <Container fluid="md">
                <Row>
                  <Col md={3}>
                    <Form className="mt-3">
                      <Form.Group as={Col} controlId="formGridState">
                        <select
                          className="form-select"
                          style={{
                            width: "150px",
                            color: "GrayText",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setselectCity(e.target.value)}
                        >
                          <option value="">Select City</option>
                          {getcitydata
                            .sort((a, b) => a.city.localeCompare(b.city)) 
                            .map((data) => (
                              <option key={data.city} value={data.city}>
                                {data.city}
                              </option>
                            ))}
                        </select>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3 mt-3" controlId="SearchBar">
                      {/* <GooglePlacesAutocomplete
                      apiKey="AIzaSyBSSh2iC9t7FJExi9-EwGXfcoq0LmTRp7M"
                      selectProps={{
                        isMulti: true,
                        placeholder: "Search Area",
                        isClearable: true,
                        value: selectlocality,
                        onChange: (val) => {
                          setselectlocality(val);
                        },
                      }}
                    /> */}
                      <Select
                        options={options}
                        isMulti // Enable multiple selection
                        onInputChange={handleInputChange}
                        onChange={handleChange1}
                        placeholder="Search area..."
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <button className="btn btn-danger mt-3">
                      <Link
                        to={{
                          pathname: "/search",
                          state: {
                            data: {
                              city: selectCity,
                              locality: selectlocality,
                              apartmentType: apartmentType,
                              propertyType: "New sale",
                            },
                          },
                        }}
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Search
                      </Link>{" "}
                    </button>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form className="mt-3 mb-3">
                      <Form.Group as={Col} controlId="formGridState">
                        <select
                          className="form-select"
                          style={{
                            width: "150px",
                            color: "GrayText",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setapartmentType(e.target.value)}
                        >
                          <option value="">BHK Type</option>
                          <option value="1 RK">1 RK</option>
                          <option value="1 BHK">1 BHK</option>
                          <option value="2 BHK">2 BHK</option>
                          <option value="3 BHK">3 BHK</option>
                          <option value="4 BHK">4 BHK</option>
                          <option value="4 BHK+">4 BHK+</option>
                        </select>
                      </Form.Group>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </TabPanel>
            <TabPanel
              style={{
                borderStyle: "ridge",
              }}
              value={value}
              index={1}
              dir={theme.direction}
            >
              <Container fluid="md">
                <Row>
                  <Col md={3}>
                    <Form className="mt-3">
                      <Form.Group as={Col} controlId="formGridState">
                        <select
                          className="form-select "
                          style={{
                            width: "150px",
                            color: "GrayText",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setselectCity(e.target.value)}
                        >
                          <option value="">Select City</option>
                          {getcitydata.map((data) => (
                            <option key={data.city} value={data.city}>{data.city}</option>
                          ))}
                        </select>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mt-3 mb-3" controlId="SearchBar">
                      {/* <GooglePlacesAutocomplete
                        apiKey="AIzaSyBSSh2iC9t7FJExi9-EwGXfcoq0LmTRp7M"
                        selectProps={{
                          isMulti: true,
                          placeholder: "Search Area",
                          isClearable: true,
                          value: selectlocality,
                          onChange: (val) => {
                            setselectlocality(val);
                          },
                        }}
                      /> */}
                      <Select
                        options={options}
                        isMulti // Enable multiple selection
                        onInputChange={handleInputChange}
                        onChange={handleChange1}
                        placeholder="Search area..."
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <button className="btn btn-danger mt-3">
                      <Link
                        to={{
                          pathname: "/search",
                          state: {
                            data: {
                              city: selectCity,
                              locality: selectlocality,
                              fullhouse: fullhouse,
                              pghostel: pghostel,
                              flatmates: flatmates,
                              apartmentType: apartmentType,
                            },
                          },
                        }}
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Search
                      </Link>{" "}
                    </button>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    {["radio"].map((type) => (
                      <div
                        key={`inline-${type}`}
                        className="mb-3"
                        style={{ color: "#252f42", fontWeight: "400" }}
                      >
                        <Form.Check
                          value={fullhouse}
                          inline
                          label="Full House"
                          name="group1"
                          type={type}
                          id={`inline-${type}-1`}
                          onChange={() => setfullhouse(!fullhouse)}
                        />
                        <Form.Check
                          inline
                          label="PG/Hostel"
                          name="group1"
                          type={type}
                          id={`inline-${type}-2`}
                          value={pghostel}
                          onChange={() => {
                            setpghostel(!pghostel);
                            setfullhouse(false);
                            setflatmates(false);
                          }}
                        />
                        <Form.Check
                          inline
                          label="Flatmates"
                          name="group1"
                          type={type}
                          id={`inline-${type}-3`}
                          value={flatmates}
                          onChange={() => {
                            setflatmates(!flatmates);
                            setfullhouse(false);
                            setpghostel(false);
                          }}
                        />
                      </div>
                    ))}
                  </Col>
                  <Col md={3}>
                    {fullhouse ? (
                      <Form>
                        <Form.Group as={Col} controlId="formGridState">
                          <select
                            className="form-select "
                            style={{
                              width: "150px",
                              color: "GrayText",
                              cursor: "pointer",
                            }}
                            onChange={(e) => setapartmentType(e.target.value)}
                          >
                            <option value="">BHK Type</option>
                            <option value="1 RK">1 RK</option>
                            <option value="1 BHK">1 BHK</option>
                            <option value="2 BHK">2 BHK</option>
                            <option value="3 BHK">3 BHK</option>
                            <option value="4 BHK">4 BHK</option>
                            <option value="4 BHK+">4 BHK+</option>
                          </select>
                        </Form.Group>
                      </Form>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Container>
            </TabPanel>
            <TabPanel
              style={{
                borderStyle: "ridge",
              }}
              value={value}
              index={2}
              dir={theme.direction}
            >
              <Container fluid="md">
                <Row>
                  <Col md={3}>
                    <Form className="mt-3">
                      <Form.Group as={Col} controlId="formGridState">
                        <select
                          className="form-select "
                          style={{
                            width: "150px",
                            color: "GrayText",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setselectCity(e.target.value)}
                        >
                          <option value="">Select City</option>
                          {getcitydata.map((data) => (
                            <option key={data.city} value={data.city}>{data.city}</option>
                          ))}
                        </select>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mt-3 mb-3" controlId="SearchBar">
                      {/* <GooglePlacesAutocomplete
                        apiKey="AIzaSyBSSh2iC9t7FJExi9-EwGXfcoq0LmTRp7M"
                        selectProps={{
                          isMulti: true,
                          placeholder: "Search Area",
                          isClearable: true,
                          value: selectlocality,
                          onChange: (val) => {
                            setselectlocality(val);
                          },
                        }}
                      /> */}

                      <Select
                        options={options}
                        isMulti // Enable multiple selection
                        onInputChange={handleInputChange}
                        onChange={handleChange1}
                        placeholder="Search area"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <button className="btn btn-danger mt-3">
                      <Link
                        to={{
                          pathname: "/search",
                          state: {
                            data: {
                              city: selectCity,
                              locality: selectlocality,
                              rent: rent,
                              buy: buy,
                              property: "Commercial",
                              propertyType: propertyType,
                            },
                          },
                        }}
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Search
                      </Link>{" "}
                    </button>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col md={3} style={{ color: "#252f42", fontWeight: "400" }}>
                    {["radio"].map((type) => (
                      <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                          inline
                          label="Rent"
                          name="group1"
                          type={type}
                          id={`inline-${type}-1`}
                          value={rent}
                          onChange={() => setrent(!rent)}
                        />
                        <Form.Check
                          inline
                          label="Buy"
                          name="group1"
                          type={type}
                          id={`inline-${type}-2`}
                          value={buy}
                          onChange={() => setbuy(!buy)}
                        />
                      </div>
                    ))}
                  </Col>

                  <Col md={3}>
                    <Form>
                      <Form.Group as={Col} controlId="formGridState">
                        <select
                          className="form-select "
                          style={{
                            width: "150px",
                            color: "GrayText",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setpropertyType(e.target.value)}
                        >
                          <option value="">Property Type</option>
                          <option value="Showroom">Showroom</option>
                          <option value="Office Space">Office Space</option>
                          <option value="Co-Working">Co-Working</option>
                          <option value="Shop">Shop</option>
                          <option value="Godown/Warehouse">
                            Godown/Warehouse
                          </option>
                          <option value="Industrial Shed">
                            Industrial Shed
                          </option>
                          <option value="Industrial Building">
                            Industrial Building
                          </option>
                          <option value="Other Business">Other Business</option>
                          <option value="Restaurant">Restaurant</option>
                        </select>
                      </Form.Group>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </TabPanel>
            <TabPanel
              style={{
                borderStyle: "ridge",
              }}
              value={value}
              index={3}
              dir={theme.direction}
            >
              <Container fluid="md">
                <Row className="mb-5">
                  <Col md={3}>
                    <Form className="mt-3">
                      <Form.Group as={Col} controlId="formGridState">
                        <select
                          className="form-select "
                          style={{
                            width: "150px",
                            color: "GrayText",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setselectCity(e.target.value)}
                        >
                          <option value="">Select City</option>
                          {getcitydata.map((data) => (
                            <option key={data.city} value={data.city}>{data.city}</option>
                          ))}
                        </select>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3 mt-3" controlId="SearchBar">
                      {/* <GooglePlacesAutocomplete
                        apiKey="AIzaSyBSSh2iC9t7FJExi9-EwGXfcoq0LmTRp7M"
                        selectProps={{
                          isMulti: true,
                          placeholder: "Search area",
                          isClearable: true,
                          value: selectlocality,
                          onChange: (val) => {
                            setselectlocality(val);
                          },
                        }}
                      /> */}
                      <Select
                        options={options}
                        isMulti // Enable multiple selection
                        onInputChange={handleInputChange}
                        onChange={handleChange1}
                        placeholder="Search area"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <button className="btn btn-danger mt-3">
                      <Link
                        to={{
                          pathname: "/search",
                          state: {
                            data: {
                              city: selectCity,
                              locality: selectlocality,
                              propertyType: "Plots",
                            },
                          },
                        }}
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Search
                      </Link>{" "}
                    </button>{" "}
                  </Col>
                </Row>
              </Container>
            </TabPanel>
          </SwipeableViews>
        </div>

        <div className="text-center mt-5 mb-3">
          <Card.Body>
            <blockquote className="blockquote mb-0">
              <Card.Title className="mb-2 " style={{ color: "black" }}>
                Are you a builder owner or agent , Need not spend!
              </Card.Title>
              <button className="btn btn-success mt-2" onClick={open}>
                Post Free property ads{" "}
              </button>{" "}
            </blockquote>
          </Card.Body>
        </div>
      </div>
      <section
        className="d-flex align-item-center p-2 justify-content-center"
        style={{ backgroundColor: "#252F42", color: "white" }}
      >
        <p className="d-flex align-center justify-content-center m-0">
          {" "}
          <GiTakeMyMoney size={25} />{" "}
          <span>
            {" "}
            Do you know how much loan you can get? Get maximum with Dream
            Estatess.
          </span>{" "}
        </p>
      </section>
      <section className="services py-4">
        <div className="container d-flex justify-content-around align-items-center">
          <div className="text-center">
            <span className="badge bg-warning text-dark">Lowest Price</span>
            <div className="icon my-2">
              {/* <a href="packer_movers_enquiry"> */}
              <Link to="/packer_movers">
                <img
                  src="../img/packer.png"
                  loading="lazy"
                  alt="Packer-mover"
                />
              </Link>
              {/* </a> */}
            </div>
            <p>Packers &amp; Movers</p>
          </div>
          <div className="text-center">
            <span className="badge bg-warning text-dark">Best Deals</span>
            <div className="icon my-2">
              <a href="/warehouse-enquiry">
                <img src="../img/warehouse.png" alt="Packer-mover" />
              </a>
            </div>
            <p>Warehouse</p>
          </div>
          <div className="text-center">
            <span className="badge bg-warning text-dark">New Offers</span>
            <div className="icon my-2">
              <a href="/interiar-enquiry">
                <img src="../img/houserent.png" alt="Packer-mover" />
              </a>
            </div>
            <p>Interior Designers</p>
          </div>
          <div className="text-center">
            <span className="badge bg-warning text-dark">Flate 30% Off</span>
            <div className="icon my-2">
              <a href="/digital-enquiry">
                <img src="../img/web-design.png" alt="Packer-mover" />
              </a>
            </div>
            <p>
              Website Design &<br /> Digitalmarketing
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
